<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <div class="row">
        <div class="col-md-1">
          <button class="btn btn-primary btn-xs" @click="saveAmountFinder()">Save</button>
        </div>
        <div class="col-md-2">
          <label>EPN Total:&nbsp;</label>
          <money currencySign="" :value="targetTotal"></money>
        </div>
        <div class="col-md-3">
          <label>Current EPN Total:&nbsp;</label>
          <money currencySign="" :value="currentTotal"></money>
        </div>
        <div class="col-md-3">
          <label>New EPN Total:&nbsp;</label>
          <money currencySign="" :value="newTotal"></money>
        </div>
        <div class="col-md-3" :class="{'text-danger' : difference}">
          <label>Difference:&nbsp;</label>
          <span><money currencySign="" :value="difference"></money></span>
          <span v-if="difference < 0"> (Reduce)</span>
          <span v-if="difference > 0"> (Add More)</span>
        </div>
      </div><!-- .row -->
    </div><!-- .panel-heading -->
  </div><!-- .panel -->
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Money from '@/plugin/element/money'
  import BatchMixin from '../../mixin/batch'

  export default {
    name: 'amount-finder',
    created() {
      this.$store.dispatch('paymentReconciliation/amountFinder/loadCurrentTransactions', this.currentTransactions)
      this.$store.dispatch('paymentReconciliation/amountFinder/loadCurrentTotal', this.epnTotal)
    },
    watch: {
      // once amount finder is started, auto select all current transactions
      started(val) {
        if (!val) {
          return
        }
        this.$store.dispatch('paymentReconciliation/amountFinder/selectAllCurrentTransaction')
      },
      batchNumber() {
        this.$store.dispatch('paymentReconciliation/amountFinder/clear')
      },
      currentTransactions(val) {
        this.$store.dispatch('paymentReconciliation/amountFinder/loadCurrentTransactions', val)
        this.$store.dispatch('paymentReconciliation/amountFinder/reselectAllCurrentTransaction', val)
      },
      epnTotal(val) {
        this.$store.dispatch('paymentReconciliation/amountFinder/loadCurrentTotal', val)
      }
    },
    computed: {
      ...mapState('paymentReconciliation/batch', {
        batchNumber: 'batchNumber',
      }),
      ...mapGetters('paymentReconciliation/batch', {
        currentTransactions: 'transactions',
        epnTotal: 'epnTotal',
      }),
      ...mapState('paymentReconciliation/amountFinder', {
        selectedOtherTransactions: 'selectedOtherTransactions',
      }),
      ...mapGetters('paymentReconciliation/amountFinder', {
        started                       : 'started',
        difference                    : 'difference',
        newTotal                      : 'newTotal',
        currentTotal                  : 'currentTotal',
        targetTotal                   : 'targetTotal',
        unselectedCurrentTransactions : 'unselectedCurrentTransactions',
      })
    },
    methods: {
      saveAmountFinder() {
        let includeTransactions = []
        let excludeTransactions = []

        includeTransactions = this.selectedOtherTransactions

        includeTransactions = includeTransactions.map((trx) => {
          let data = {
            type: trx.type,
          }
          if ('payment' === trx.type) {
            data.paymentId = trx.paymentId
          }
          if ('refund' === trx.type) {
            data.refundId = trx.refundId
          }
          if ('nsf' === trx.type) {
            data.refundId = trx.nsfId
          }
          return data
        })

        excludeTransactions = this.unselectedCurrentTransactions

        excludeTransactions = excludeTransactions.map((trx) => {
          let data = {
            type: trx.type,
          }
          if ('payment' === trx.type) {
            data.paymentId = trx.paymentId
          }
          if ('refund' === trx.type) {
            data.refundId = trx.refundId
          }
          if ('nsf' === trx.type) {
            data.nsfId = trx.nsfId
          }
          return data
        })

        this.$store.dispatch('paymentReconciliation/amountFinder/saveAmountFinder', {
          batchNumber: this.batchNumber,
          newAmount: this.targetTotal,
          includeTransactions: includeTransactions,
          excludeTransactions: excludeTransactions
        }).then(() => {
          this.$store.dispatch('paymentReconciliation/amountFinder/clear')
          this.$store.dispatch('paymentReconciliation/batch/fetch')
        })
      },
    },
    components: {
      Money
    },
    mixins: [
      BatchMixin
    ]
  }
</script>
